@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (pageReady && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto cf-page" [class.cf-compact]="isMobile">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Package Group</h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Give the group a meaningful name, assign a colour and then add all of the individual packages to the group.
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <div style="width:100%">
            <div class="field mb-4 col-12">
              <label for="pgname" class="font-medium">Name of the Package Group</label>
              @if (PackageGroup.packagegroupname == 'Popular') {
                <input [disabled]="true" [(ngModel)]="PackageGroup.packagegroupname" id="pgname" type="text" [ngStyle]="{'border-color': (packagegroupNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
              }
              @if (PackageGroup.packagegroupname != 'Popular') {
                <input [(ngModel)]="PackageGroup.packagegroupname" id="pgname" type="text" [ngStyle]="{'border-color': (packagegroupNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
              }
            </div>
            @if (!packagegroupNameValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an Package Group Name.</div>
            }
          </div>
          <div class="field mb-4 col-12">
            <label for="colour" class="font-medium">Colour</label><br/>
            <p-colorpicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="PackageGroup.colour"></p-colorpicker>
            <input style="width:200px;" [(ngModel)]="PackageGroup.colour" id="hexcolour" type="text" pInputText>
          </div>
          @if (!packagegroupListValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must add packages to your package group.</div>
          }
          <div style="clear:both; width:100%">
            &nbsp;
          </div>
          @if (!isMobile) {
            <div class="col-12 md:col-6 drag-column">
              <h5>Available Packages</h5>
              <p-table [value]="ListPackages">
                <ng-template #header>
                  <tr>
                    <th style="width:90%">Name</th>
                    <th style="width:10%">&nbsp;</th>
                  </tr>
                </ng-template>
                <ng-template #body let-product>
                  <tr pDraggable="products" (onDragStart)="dragStart($event, product)" (onDragEnd)="dragEnd()">
                    <td>{{product.name}}</td>
                    <td>
                      <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToList(product)">
                        <span class="pi pi-angle-right"></span>
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              @if (ListPackages == null) {
                <div style="padding: 15px;">
                  <i>No extras available, add some <a href="/packages/0">here</a></i>
                </div>
              }
            </div>
          }
          <div class="cf-col col-12 md:col-6 drop-column" pDroppable="products" (onDrop)="drop()">
            <!-- On a phone the Available list is this dropdown instead - see addPicked. -->
            @if (isMobile) {
              <div class="cf-add-row">
                <p-select [options]="ListPackages" [(ngModel)]="picked['packages']" [ngModelOptions]="{standalone: true}" optionLabel="name" placeholder="Add a package"
                [filter]="true" filterBy="name" appendTo="body" emptyMessage="None available"></p-select>
                <button pButton pRipple type="button" class="p-button-success"
                  [disabled]="picked['packages'] == null" (click)="addPicked('packages', AddToList)"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add</span></button>
                </div>
              }
              <h5>Selected Packages</h5>
              <p-table [value]="PackageGroup.packages">
                <ng-template  #header let-columns>
                  <tr>
                    <th>&nbsp;</th>
                    <th style="width:70%">Name</th>
                    <th style="width:10%">&nbsp;</th>
                    <th class="row-move-cell"></th>
                  </tr>
                </ng-template>
                <ng-template #body let-product let-columns="columns" let-index="rowIndex">
                  <tr [pReorderableRow]="index">
                    <td>
                      <span class="pi pi-bars" pReorderableRowHandle></span>
                    </td>
                    @if (!product.disabled) {
                      <td>{{product.name}}</td>
                    }
                    @if (product.disabled) {
                      <td><i>{{product.name}}</i> - <b>DISABLED</b></td>
                    }
                    <td>
                      <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="RemoveFromList(product)">
                        <span class="pi pi-angle-left"></span>
                      </button>
                    </td>
                    <td class="row-move-cell"><app-row-move [list]="PackageGroup.packages" [index]="index"></app-row-move></td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          <div class="col-12">
            <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
              <span class="pi pi-pencil" style="margin-right:8px;"></span>
            Save Changes</button>
            &nbsp;
            <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
              <span class="pi pi-times" style="margin-right:8px;"></span>
            Cancel</button>
          </div>
        </div>
      </div>
    </div>
  }
